import React, { useState } from "react";
import "../PricingCard/PricingCard.css";
import LoginModal from "../LoginModal";
import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import "../StripePaymentCard/StripePaymentCard.css";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { createSubscriptionAPI } from "../../utils/requests/proposals";
import { toastError, toastSuccess } from "../../utils/helpers/helper";
import Card from "react-bootstrap/Card";
import { getUserDetail } from "../../store/actions/users/users.actions";
import { UPDATE_PRICING_MODAL } from "../../store/actionTypes";

const useOptions = () => {
  return {
    style: {
      base: {
        iconColor: "#c4f0ff",
        color: "#000",
        fontWeight: "500",
        fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        fontSize: "16px",
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#fce883",
        },
        "::placeholder": {
          color: "#87BBFD",
        },
      },
      invalid: {
        iconColor: "#eb1c26",
        color: "#eb1c26",
      },
    },
  };
};

const OneTimePricingCard = ({ num, product, profile, close }) => {
  const [loginModalShow, setLoginModalShow] = useState(false);
  const dispatch = useDispatch();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const options = useOptions();
  const { user } = useSelector((state) => state.auth);

  const handleSubmit = async (event) => {
    setError(null);
    event.preventDefault();
    if (!user) {
      setLoginModalShow(true);
      return;
    }

    if (!stripe || !elements) {
      return;
    }

    if (error) {
      elements.getElement("card").focus();
      return;
    }

    const payload = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });
    if (payload.error) {
      setError(payload.error);
    } else {
      setLoading(true);
      let data = {
        payment_method: payload.paymentMethod.id,
        price_id: product.price_id,
        amount: product.price,
        description: product?.features,
        ...user,
      };

      if (product.key == 'site_router') {
        data = {
          one_time_payment: true,
          ...data,
        }
      } else if (product.key == 'deals_credit') {
        data = {
          deals_credit: true,
          ...data,
        }
      } else if (product.key == 'credit') {
        data = {
          credit: true,
          ...data,
        }
      } else {
        data = {
          life_time_payment: true,
          ...data,
        }
      }

      createSubscriptionAPI(data)
        .then(async (response) => {
          toastSuccess("Payment is Successful");
          dispatch({
            type: UPDATE_PRICING_MODAL,
            pricing_modal: false,
          })
          dispatch(getUserDetail())
          if (product.key == 'lifetime_offer')
            document.location.href = "/";
          close(true);

        })
        .catch((error) => {
          setLoading(false);
          toastError(`Payment Failed`);
        });
      setLoading(true);
    }
  };

  return (
    <>
      <Row className="text-end d-flex justify-content-end fw-bolder" style={{ fontSize: '15px' }}>
        Payment
      </Row>
      <Card className="text-start p-2 h-100">
        <Card.Body>
          <Row className="fw-">
            <Card.Img
              variant="top"
              src={product.icon}
              className="col-md-2"
              style={{ width: "100px" }}
            />
            <Card.Title className="col-md-12 align-self-center fw-bolder">
              {product.key == 'site_router' ? product.title : <span dangerouslySetInnerHTML={{ __html: product.title }} />}
            </Card.Title>
          </Row>
          <Card.Text className="fw-semibold my-3">
            {product.key == 'site_router' ? product.features : <span dangerouslySetInnerHTML={{ __html: product.features }} />}
          </Card.Text>
          {(product.key !== 'deals_credit' || product.key !== 'credit') &&
            <>
              <Card.Text className="my-4 mb-0">{product.key == 'site_router' ? "Starting" : "Price"}</Card.Text>
              <Card.Text>
                <span className="h4 fw-bolder">${product.price}</span> - {product?.key == 'site_router' ? "One-time payment not included in any other subscription" : product?.key == 'deals_credit' || product?.key == 'credit' ? `${product.price} Credits` : "Lifetime Access"}
              </Card.Text>
            </>
          }
          <Row className="mt-auto h-25 text-center ">
            <form onSubmit={handleSubmit}>
                <label>Card details</label>
                {error && <Alert variant="danger">{error.message}</Alert>}
                <CardElement
                options={options}
                onChange={(e) => {
                    setError(e.error);
                    // setCardComplete(e.complete);
                }}
                />
                <Button
                type="submit"
                variant="primary"
                className="p-3 text-center justify-content-center"
                disabled={!stripe || loading}
                >
                {loading ? "processing..." : "Pay"}
                </Button>
            </form>
          </Row>
        </Card.Body>
      </Card>
      <LoginModal
        show={loginModalShow}
        onHide={() => setLoginModalShow(false)}
      />
    </>
  );
};

export default OneTimePricingCard;
